"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function AccessingPageLayout({ iconName, title, subtitle, buttonText, buttonClick, onNeedAssistanceClick, }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsxs)(Content, { children: [(0, jsx_runtime_1.jsx)(StyledBrokenLinkImage, { name: iconName, width: 140, height: 140 }), (0, jsx_runtime_1.jsx)(exports.StyledTitle, { children: title }), (0, jsx_runtime_1.jsx)(StyledSubtitle, { children: subtitle }), (0, jsx_runtime_1.jsx)(OpenInAppButton, { onClick: buttonClick, children: buttonText })] }), (0, jsx_runtime_1.jsx)(ui_1.FooterForGrasshopperErrorPage, { onClick: onNeedAssistanceClick })] }));
}
exports.default = AccessingPageLayout;
const Container = styled_components_1.default.div `
  ${ui_1.deviceMainScreenLandscape.mobile `
      height: 100vh;
  `}

  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.brandedBlack};
`;
const StyledBrokenLinkImage = (0, styled_components_1.default)(ui_1.Icon) `
  display: block;

  ${ui_1.deviceMainScreenLandscape.mobile `
    display: none;
  `}
`;
const Content = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 16px;
  align-items: center;
  min-height: 0;
  flex: 1;

  ${ui_1.deviceMainScreenLandscape.mobile `
    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
  `}
`;
exports.StyledTitle = styled_components_1.default.h1 `
  margin-bottom: 16px;
  font-weight: 400;
  font-size: 32px;
  line-height: 40px;
  color: ${({ theme }) => theme.designSystem.whiteSecondary};
  text-align: center;
  user-select: none;
`;
const StyledSubtitle = styled_components_1.default.h2 `
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  text-align: center;
  user-select: none;
  margin: 0;
  margin-bottom: 28px;

  color: ${({ theme }) => theme.designSystem.whiteSecondary};

  ${ui_1.deviceMainScreen.mobileS `
  min-height: 61px;
  
  margin-bottom: 54px;
`}
`;
const OpenInAppButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  padding: 12px 13px;
  box-sizing: border-box;
  line-height: 24px;
  background: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.background};
  border-radius: 4px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.text};
  font-family: Source Sans Pro;

  margin-top: 10vh;

  ${ui_1.deviceMainScreen.mobile `
    margin: 0;
  `}

  ${ui_1.deviceMainScreenLandscape.tablet `
    margin: 0;
  `}
`;
